import React from 'react';
import { Send } from 'lucide-react';
import clsx from 'clsx';

interface AIChatInputProps {
    input: string;
    setInput: (value: string) => void;
    handleSend: () => void;
    isLoading: boolean;
    isDark: boolean;
}

export const AIChatInput: React.FC<AIChatInputProps> = ({
    input,
    setInput,
    handleSend,
    isLoading,
    isDark,
}) => {
    return (
        <div className={clsx(
            'p-4 border-t',
            isDark ? 'border-slate-700 bg-slate-900/50' : 'border-slate-200 bg-slate-50'
        )}>
            <form onSubmit={(e) => { e.preventDefault(); handleSend(); }} className="flex gap-2">
                <input
                    type="text"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    placeholder="Ask me anything about your reliability data..."
                    disabled={isLoading}
                    className={clsx(
                        'flex-1 px-4 py-2 rounded-lg border text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 disabled:opacity-50',
                        isDark
                            ? 'bg-slate-800 border-slate-600 text-white placeholder-slate-400'
                            : 'bg-white border-slate-300 text-slate-900 placeholder-slate-500'
                    )}
                />
                <button
                    type="submit"
                    disabled={!input.trim() || isLoading}
                    className={clsx(
                        'px-4 py-2 rounded-lg font-medium transition-all flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed',
                        'bg-gradient-to-r from-purple-500 to-blue-600 text-white hover:shadow-lg'
                    )}
                >
                    <Send className="w-4 h-4" />
                    Send
                </button>
            </form>
        </div>
    );
};
